import { UPDATE_RESERVATION_SUCCESS } from "@/store/actions";
import queryClient from "../queryClient";
import { CUSTOMERS_KEY } from "./hooks";
import store from '@/store/configureStore';

export function updateCacheDetailCustomer(customer) {
    queryClient.setQueryData(
        [CUSTOMERS_KEY, 'detail', customer.id],
        customer,
    );
}

/**
 * 
 * @param {any[]} customers 
 */
export function updateCacheDetailCustomers(customers) {
    for (const customer of customers) {
        updateCacheDetailCustomer(customer);
    }
}

// LEGACY

/**
 * Get every given customers' reservations and update 
 * them with the its new values.
 * ### ONLY USE IT FOR LEGACY COMPATIBILITY PURPOSE.
 * - It will be removed eventually
 * @param {any} customer
 * @param {boolean} remove
 */
export function updateStoreCustomerReservations(customer) {
    const reservations = store
        .getState()
        .reservationsReducer
        .reservations
        .filter(reservation => reservation.customer?.id === customer.id);

    for (const reservation of reservations) {
        store.dispatch({ 
            type: UPDATE_RESERVATION_SUCCESS, 
            reservation: {
                ...reservation,
                customer,
            }, 
            loading: false,
            error: null, 
        });
    }
}

/**
 * 
 * @param {number} customerId 
 */
export function removeStoreCustomerFromReservations(customerId) {
    const reservations = store
        .getState()
        .reservationsReducer
        .reservations
        .filter(reservation => reservation.customer?.id === customerId);

    for (const reservation of reservations) {
        store.dispatch({ 
            type: UPDATE_RESERVATION_SUCCESS, 
            reservation: {
                ...reservation,
                customer: null,
            }, 
            loading: false,
            error: null, 
        });
    }
}


// WEBPACK FOOTER //
// ./src/queries/customers/utils.js